import React, { useState } from 'react';
import { Info } from 'lucide-react';

const Slider = ({ label, value, onChange, description }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <label className="block text-sm">{label}</label>

        <div
          className="relative"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <Info className="h-4 w-4 text-gray-400 cursor-pointer" />

          {showTooltip && (
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 bg-gray-800 text-white text-xs rounded py-1 px-2 z-10 shadow-lg">
              {description}
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center">
        <input
          type="range"
          min="0"
          max="100"
          step="10"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value, 10))}
          className="
            w-full h-[6px]
            rounded-full appearance-none cursor-pointer

            /* Track */
            bg-[#181a20]

            /* Webkit Thumb */
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:h-4
            [&::-webkit-slider-thumb]:w-4
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-blue-500
            [&::-webkit-slider-thumb]:transition
            [&::-webkit-slider-thumb]:hover:bg-blue-600
            [&::-webkit-slider-thumb]:shadow-lg

            /* Mozilla Thumb */
            [&::-moz-range-thumb]:h-4
            [&::-moz-range-thumb]:w-4
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:bg-blue-500
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:transition
            [&::-moz-range-thumb]:hover:bg-blue-600
            [&::-moz-range-thumb]:shadow-lg

            /* Focus state */
            focus:outline-none
          "
        />

        <span className="ml-4 text-sm font-medium text-white">{value}%</span>
      </div>
    </div>
  );
};

export default Slider;